import { Link, Navigate, useNavigate } from 'react-router'
import { ArrowLeft } from 'lucide-react'
import { useAuth } from '@/auth/AuthContext'
import { PageHeader } from '@/components/PageHeader'
import { TenantForm } from '@/components/tenants/TenantForm'
import { toast } from '@/components/ui/toast'
import { useCreateTenant } from '@/hooks/useOpsTenants'

/** Staff ADMIN onboarding a new organization and inviting its first owner. */
export function OpsTenantNewPage() {
  const { user } = useAuth()
  const navigate = useNavigate()
  const create = useCreateTenant()

  if (user?.role !== 'ADMIN') return <Navigate to="/ops/tenants" replace />

  return (
    <>
      <PageHeader
        eyebrow={
          <Link to="/ops/tenants" className="inline-flex items-center gap-1 hover:text-foreground">
            <ArrowLeft className="size-3.5" />
            Tenants
          </Link>
        }
        title="New tenant"
        description="Set up the organization, then invite its owner."
      />
      <TenantForm
        mode="create"
        cancelTo="/ops/tenants"
        onSubmit={async (input) => {
          const tenant = await create.mutateAsync(input)
          // The tenant commits before the invitation is sent; if that failed, say so rather than claim it went out.
          const invited = tenant.team.invitations.some((row) => row.email === input.ownerEmail)
          if (invited) {
            toast.success(`${tenant.name} created. Invitation sent to ${input.ownerEmail}`)
          } else {
            toast.error(`${tenant.name} created, but the owner invitation failed. Invite them from this page.`)
          }
          navigate(`/ops/tenants/${tenant.id}`)
        }}
      />
    </>
  )
}
